import { render } from "./GetStarted.vue?vue&type=template&id=15a0051a&scoped=true"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"

import "./GetStarted.vue?vue&type=style&index=0&id=15a0051a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a0051a"]])

export default __exports__